import "./ActionMenu.html";
import "./ActionMenu.scss";
import type { IComponentOptions, IControllerConstructor } from "angular";
import { ActionMenuComponentController } from "./ActionMenuComponentController";

export class ActionMenuComponent implements IComponentOptions {
    public bindings: any;

    public templateUrl: string;

    public controller: IControllerConstructor;

    constructor() {
        this.bindings = {
            actions: "<?",
        };
        this.templateUrl = "/App/Modules/Gui/Components/ActionMenu/ActionMenu.html";
        this.controller = ActionMenuComponentController;
    }
}
